<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
         <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="['/home']" >Home</a>
            </li>
            <li class="breadcrumb-item">
                <a>DataBus</a>
            </li>            
            <li class="breadcrumb-item">
                <a>Health Dashboard</a>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row mt-2">
        <div class="col-lg-12">
            <div class="card mt-2">
                <div class="card-body">
                    <!-- Health Statistics -->
                    <div class="health-stats">
                        <div class="health-stat-card bg-danger" [ngClass]="{'bg-opacity-20': expiredCount === 0}">
                            <h3>{{expiredCount}}</h3>
                            <p>Expired Licenses</p>
                        </div>
                        <div class="health-stat-card bg-warning" [ngClass]="{'bg-opacity-20': staleCount === 0}">
                            <h3>{{staleCount}}</h3>
                            <p>Stale Instances (>30min)</p>
                        </div>
                        <div class="health-stat-card bg-warning" [ngClass]="{'bg-opacity-20': errorInstanceCount === 0}">
                            <h3>{{errorInstanceCount}}</h3>
                            <p>Instances with Errors</p>
                        </div>
                        <div class="health-stat-card bg-success" [ngClass]="{'bg-opacity-20': healthyCount === 0}">
                            <h3>{{healthyCount}}</h3>
                            <p>Healthy Instances</p>
                        </div>
                    </div>

                    <!-- Unhealthy Instances Table -->
                    <h5 class="mb-3">Unhealthy Instances</h5>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="sortable-header" (click)="sortTable('computerName')">Computer Name {{getSortIcon('computerName')}}</th>
                                <th class="sortable-header" (click)="sortTable('customerName')">Customer {{getSortIcon('customerName')}}</th>
                                <th>Health Issues</th>
                                <th class="sortable-header" (click)="sortTable('expiry')">Expiry {{getSortIcon('expiry')}}</th>
                                <th class="sortable-header" (click)="sortTable('timeStamp')">Last Report {{getSortIcon('timeStamp')}}</th>
                                <th class="sortable-header" (click)="sortTable('version')">Version {{getSortIcon('version')}}</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="unhealthyInstances.length > 0">
                            <tr class="gradeX" *ngFor="let status of unhealthyInstances">
                                <td>{{status.computerName}}</td>
                                <td>{{status.customerName}}</td>
                                <td>
                                    <span *ngIf="isExpired(status)" class="badge badge-expired health-indicator">Expired</span>
                                    <span *ngIf="isStale(status)" class="badge badge-stale health-indicator">Stale</span>
                                    <span *ngIf="hasErrors(status)" class="badge badge-error health-indicator clickable-badge" (click)="showErrorDetails(status);errorDetailsModal.show()">{{status.errorCount}} Errors</span>
                                </td>
                                <td [ngClass]="{'text-danger':convertToDate(status.expiry) < inOneMonth,'text-warning':convertToDate(status.expiry) < inTwoMonth}">{{status.expiry | relativeDate}}</td>
                                <td [ngClass]="{'text-danger':convertToDate(status.timeStamp) < oneHourAgo}">{{status.timeStamp | relativeDate}}</td>
                                <td>{{status.version}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="unhealthyInstances.length == 0">
                            <tr class="gradeX">
                                <td colspan="6" class="text-center text-success">
                                    <i class="fa fa-check-circle"></i> All instances are healthy
                                </td>  
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Error Details Modal -->
<div class="modal fade" bsModal #errorDetailsModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-error-details">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Error Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="errorDetailsModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="selectedErrorStatus">
          <div class="col-12">
            <div class="alert alert-warning">
              <h6><strong>Instance Information</strong></h6>
              <table class="table table-sm table-borderless">
                <tbody>
                  <tr>
                    <td><strong>Computer Name:</strong></td>
                    <td>{{selectedErrorStatus.computerName}}</td>
                  </tr>
                  <tr>
                    <td><strong>Customer:</strong></td>
                    <td>{{selectedErrorStatus.customerName}}</td>
                  </tr>
                  <tr>
                    <td><strong>Version:</strong></td>
                    <td>{{selectedErrorStatus.version}}</td>
                  </tr>
                  <tr>
                    <td><strong>Error Count:</strong></td>
                    <td><span class="badge bg-danger">{{selectedErrorStatus.errorCount}}</span></td>
                  </tr>
                  <tr>
                    <td><strong>Last Report:</strong></td>
                    <td>{{selectedErrorStatus.timeStamp | relativeDate}}</td>
                  </tr>
                  <tr>
                    <td><strong>Start Time:</strong></td>
                    <td>{{selectedErrorStatus.startTime | relativeDate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="alert alert-danger" *ngIf="selectedErrorStatus.errorMessage">
              <h6><strong>Error Message</strong></h6>
              <p class="mb-0" style="white-space: pre-wrap;">{{selectedErrorStatus.errorMessage}}</p>
            </div>
            
            <div class="alert alert-info">
              <h6><strong>Additional Information</strong></h6>
              <p class="mb-0">
                This instance has reported <strong>{{selectedErrorStatus.errorCount}}</strong> error(s).
                <span *ngIf="!selectedErrorStatus.errorMessage">
                  For detailed error logs and stack traces, please check the DataBus instance logs on 
                  <strong>{{selectedErrorStatus.computerName}}</strong>.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="errorDetailsModal.hide()" class="btn btn-primary">Close</button>
      </div>
    </div>
  </div>
</div>
